import { Attribute } from './attribute';
import { Input_Inst } from './input_Inst';
import { CommonEnums } from 'src/app/shared/common.enums';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class Input {
    input_Inst: Input_Inst;

    attributes: Array<Attribute>;
    reusableAttributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    reusableInstName: string;

    change_Ind: string;
    attr_Tab_Change_Ind: string;
    gen_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.input_Inst = new Input_Inst();

        this.attributes = new Array<Attribute>();
        this.reusableAttributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.reusableInstName = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(inputTmp: Input): Input {
        let input: Input = new Input();
        input.copyFrom(inputTmp);
        return input;
    }

    copy(): Input {
        let inputTmp: Input = new Input();

        inputTmp.input_Inst = this.input_Inst.copy();

        inputTmp.attributes = AttributesUtil.getInstance().copy(this.attributes)
        inputTmp.reusableAttributes = AttributesUtil.getInstance().copy(this.reusableAttributes)

        inputTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        inputTmp.ref_Id = this.ref_Id;
        inputTmp.ref_Cd = this.ref_Cd;
        inputTmp.fldr_Id = this.fldr_Id;
        inputTmp.reusableInstName = this.reusableInstName;

        inputTmp.change_Ind = this.change_Ind;
        inputTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        inputTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;

        inputTmp.error_Cd = this.error_Cd;
        inputTmp.error_Msg = this.error_Msg;

        return inputTmp;
    }

    copyFrom(inputTmp: Input): void {
        this.input_Inst.copyFrom(inputTmp.input_Inst);

        let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
        attributesUtil.copyFrom(this.attributes, inputTmp.attributes);
        attributesUtil.copyFrom(this.reusableAttributes, inputTmp.reusableAttributes);

        this.nativeDbTyp_Id = inputTmp.nativeDbTyp_Id;
        this.ref_Id = inputTmp.ref_Id;
        this.ref_Cd = inputTmp.ref_Cd;
        this.fldr_Id = inputTmp.fldr_Id;
        this.reusableInstName = inputTmp.reusableInstName;

        this.change_Ind = inputTmp.change_Ind;
        this.attr_Tab_Change_Ind = inputTmp.attr_Tab_Change_Ind;
        this.gen_Tab_Change_Ind = inputTmp.gen_Tab_Change_Ind;

        this.error_Cd = inputTmp.error_Cd;
        this.error_Msg = inputTmp.error_Msg;
    }

    compare(inputTmp: Input): string {
        let inputString: string = this.toString();
        let inputTmpString: string = inputTmp.toString();

        if (inputString != inputTmpString) {
            return inputString + ', ' + inputTmpString;
        }

        return '';
    }

    toString(): string {
        let attributesUtil: AttributesUtil = AttributesUtil.getInstance();

        return "Input [input_Inst=" + this.input_Inst.toString() +
            ", attributes=" + attributesUtil.toString(this.attributes) +
            ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id + ", reusableAttributes=" + attributesUtil.toString(this.reusableAttributes) +
            ", reusableInstName=" + this.reusableInstName + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + "]";
    }
}